// export const customerHistoryWidth = {
//     id: 10,
//     stores: 20,
//     email: 20,
//     raitings: 10,
//     activeProducts: 10,
//     country: 10,
//     website: 20
//   }
export const customerHistoryWidth = {
    id: 180,
    stores: 350,
    email: 350,
    ratings: 180,
    activeProducts: 180,
    country: 180,
    website: 350
}